import MunicipalPortalAAppService from "application/platform/municipal-portal-service";
import { ACTION_TYPES, useCustomPageDispatch } from "./custom-page-context";
import { useAppState } from "main/context/app-context";

export const useCustomPageController = () => {
    const customPageDispatch = useCustomPageDispatch();
    const { applicationData } = useAppState();

    const loadCustomPage = async (slug: string) => {
        try {
            customPageDispatch({
                type: ACTION_TYPES.loadCustomPageRequest,
            });

            const customPage = await MunicipalPortalAAppService.getCustomPage(slug);

            customPageDispatch({
                type: ACTION_TYPES.loadCustomPageSuccess,
                payload: customPage,
            });
        } catch (error: any) {
            console.error('Failed to fetch custom page:', error);
            customPageDispatch({
                type: ACTION_TYPES.loadCustomPageFailure,
                payload: error?.message || 'Erro ao carregar página',
            });
        }
    };

    const clearCustomPage = () => {
        customPageDispatch({
            type: ACTION_TYPES.clearCustomPage,
        });
    };

    return {
        loadCustomPage,
        clearCustomPage,
    };
}
